module.exports = __webpack_public_path__ + "static/media/start.7d9c3e7f.svg";